import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { DroppedFilesResourcesStatus } from "../@types/rldynamicanalysis";
import api from "../api";
import { sampleReportKeys } from "../queryKeys";

/**
 * Fetches resources status
 * @param hash samples hash value
 * @param analysisId analysisId for specific analysis
 * @param options useQueryOptions that can be passed to hook
 * @return { fetchStatus, data }
 */
const useGetRLSandboxResourcesStatus = <T = DroppedFilesResourcesStatus>(
  hash: string,
  analysisId: string,
  isNetworkReport = false,
  options?: Partial<UseQueryOptions>
) => {
  const { refetch, data } = useQuery({
    queryKey: sampleReportKeys.rlSandboxResourcesStatus(
      hash,
      analysisId,
      isNetworkReport
    ),
    queryFn: () =>
      api.getRLSandboxResourcesStatus(hash, analysisId, isNetworkReport),
    enabled: false,
    select: ({ data: responseData }) => responseData,
    ...options
  });

  const fetchStatus = () => {
    refetch();
  };

  return { fetchStatus, data: data as DroppedFilesResourcesStatus | undefined };
};

export default useGetRLSandboxResourcesStatus;
